/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeywordDto } from '../../models/keyword-dto';

export interface KeywordControllerFindOneV1$Params {
  id: number;
  value?: string;
}

export function keywordControllerFindOneV1(http: HttpClient, rootUrl: string, params: KeywordControllerFindOneV1$Params, context?: HttpContext): Observable<StrictHttpResponse<KeywordDto>> {
  const rb = new RequestBuilder(rootUrl, keywordControllerFindOneV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('value', params.value, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KeywordDto>;
    })
  );
}

keywordControllerFindOneV1.PATH = '/api/v1/keyword/{id}';
